import { ClassType } from '@frontend/common';
import { DefaultBadge } from '@frontend/components/badge';
import React from 'react';

export interface StatusBadgeProps<T> {
    value?: React.ReactNode;
    colorMap: Map<StatusBadgeProps<T>['value'][], ClassType>;
    displayMap?: Map<StatusBadgeProps<T>['value'], string>;
    textSize?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl';
}

export const StatusBadge = <T extends any>(props: StatusBadgeProps<T>) => {
    const colorVariants = {
        [ClassType.PRIMARY]: 'bg-brand-primary',
        [ClassType.SECONDARY]: 'bg-brand-secondary',
        [ClassType.INFO]: 'bg-status-info',
        [ClassType.SUCCESS]: 'bg-status-success',
        [ClassType.WARNING]: 'bg-status-warning',
        [ClassType.DANGER]: 'bg-status-danger',
        [ClassType.LIGHT]: 'bg-background-surface',
        [ClassType.DARK]: 'bg-foreground-default',
        [ClassType.DEBUG]: 'bg-status-info',
        [ClassType.ALERT]: 'bg-status-warning',
        [ClassType.DISABLED]: 'bg-status-disabled'
    };

    const textSizeVariants = {
        xs: 'text-xs',
        sm: 'text-sm',
        base: 'text-base',
        lg: 'text-lg',
        xl: 'text-xl',
        '2xl': 'text-2xl',
        '3xl': 'text-3xl',
        '4xl': 'text-4xl',
        '5xl': 'text-5xl',
        '6xl': 'text-6xl'
    };
    const textSize = props.textSize ? textSizeVariants[props.textSize] : 'text-sm';
    if (!props.value) {
        return <></>;
    }
    return (
        <DefaultBadge
            label={props.displayMap?.get(props.value) ?? props.value}
            styles={{
                container: {
                    color: colorVariants[getValueFromArrayMap(props.colorMap, props.value)]
                },
                label: `${textSize} text-background-surface`
            }}
        />
    );
};

function getValueFromArrayMap<T>(map: Map<T[], ClassType>, value: T): ClassType {
    for (const [k, v] of map) {
        if (k.includes(value)) return v;
    }
    return ClassType.PRIMARY;
}
